import React, { useEffect, useState } from 'react';
import { useScheduler } from '../../schedulerContext';

export const InputTable = ({ data })=> {
  const { parameters, setParameters } = useScheduler();

  
  const [values, setValues] = useState(
    Object.keys(data).reduce((acc, key) => {
      acc[data[key].name] = parameters.input?.[data[key].name] || '';
      return acc;
    }, {})
  );

const handleInputChange = (event, variable, parent = null) => {
  const value = event.target.value;

  setValues(prevValues => {
    let updatedValues;

    if (parent) {
      updatedValues = {
        ...prevValues,
        [parent]: {
          ...(prevValues[parent] || {}),
          [variable]: value,
        },
      };
    } else {
      updatedValues = { ...prevValues, [variable]: value };
    }

    setParameters(p => ({ ...p, input: updatedValues }));
    return updatedValues;
  });
};


 

const tableRows = Object.values(data).map(item => {
    return (
      <tr key={item.name}>
        <td>{item.caption || item.name}</td>
        <td>{item?.type === "Table" ? "XML" : item.dataType}</td>
        <td>
        <input
              style={{ width: "120px", outline: "none" }}
              type="text"
              value={(values[item.name] || "").replace(/\n/g, "\\n")}
              onChange={(event) => handleInputChange(event, item.name)}
              spellCheck="false"
            />

        </td>
      </tr>
    );
});


  return (
    <div style={{maxWidth:"350px",width:"350px"}}>
      <table>
        <thead>
          <tr>
            <th style={{maxWidth:"120px",width:"120px"}}>Variable</th>
            <th style={{maxWidth:"120px",width:"120px"}}>Datatype</th>
            <th style={{maxWidth:"120px",width:"120px"}}>Value</th>
          </tr>
        </thead>
        {
          (data && Object.keys(data).length > 0) ?  <tbody>
          {tableRows}
        </tbody>:   <tbody>
            <tr>
              <td colSpan={3} style={{ textAlign: 'center' }}>
                No data available
              </td>``
            </tr>
          </tbody>
        }
       
      </table>
    </div>

  );
}


